import React, { useEffect } from "react";
import { inject } from "mobx-react";
import { withRouter } from "react-router-dom";
import Container from "reactstrap/lib/Container";
import Row from "reactstrap/lib/Row";
import { useQuery } from "@apollo/client";
import { BEAUTIFUL_PHONES_QUERY, MOBILE_TAGS_QUERY } from "Services/queries";
import withDefaultParams, { generateUrl } from "Services/withDefaultParams";
import { useWithDefaultParams } from "Services/useWithDefaultParams";
import { LimitTariffsFromOperator } from "Constants/Limit";
import TagButtonComponent from "Containers/TagButtonComponent";
import BeautifulNumbersRow from "Containers/BeautifulNumbersRow";
import { PaddingBottom } from "ComponentsUI/Spacings";
import BeautifulNumbersWrapper from "ComponentsUI/BeautifulNumbers/BeautifulNumbersWrapper";
import { ShowMoreButton } from "ComponentsUI/Buttons";
import { Redirect404 } from "ComponentsUI/Redirects";
import { OfferBlock } from "ComponentsUI/InfoBlocks";
import { EmptyStubWrapper } from "ComponentsUI/EmptyStub";
import { NoTariffsInfo } from "ComponentsUI/InfoBlocks";
import { StubOperatorTariffs } from "ComponentsUI/Stub";
import Metrika from "Services/Metrika";
import { YANDEX_TARGETS } from "Constants/metriks/yandex-targets";
import configRouters from "Configs/routes";
import { Helmet } from "react-helmet-async";

const Page = (props) => {
	let {
		ApplicationModel: {
			siteConfig,
			windowSizeModel: { windowSizes },
			text,
		},
		match: { params },
	} = props;
	const match = useWithDefaultParams();
	let regionUrl = match?.params?.regionUrl;

	const canonical = () => {
		let location = generateUrl(configRouters.BeautifulNumbers.route, {
			regionUrl: regionUrl,
			tagCode: params.tagCode,
		});
		let href = `${siteConfig.ssl === true ? `https` : "http"}://${
			siteConfig.domain_name_full
		}${location}`;
		return (
			<Helmet>
				<link rel="canonical" href={href} />
			</Helmet>
		);
	};

	useEffect(() => {
		Metrika.getInstance().yandex.sendEvent(YANDEX_TARGETS.OPEN_NOMERA_REGION, []);
	}, [params.tagCode]);

	// Проверка на присутствие тега в системе
	if (params.regionUrlComing === "operatory") {
		return <Redirect404 message404={"params.regionUrlComing === operatory"} />;
	}

	// Запрос на получение доступных тегов
	const mobileTagsQuery = useQuery(MOBILE_TAGS_QUERY, {
		variables: {
			region_url: regionUrl,
			tag_type: "beauty",
		},
		notifyOnNetworkStatusChange: true,
	});

	const filter = [];
	if (regionUrl) {
		filter.push(`provider.region.url=${regionUrl}`);
	}

	if (props.match.params.tagCode) {
		filter.push(`tags.translit=${props.match.params.tagCode}`);
	}

	// Запрос на получение номеров
	const beautifulPhonesQuery = useQuery(BEAUTIFUL_PHONES_QUERY, {
		variables: {
			filter: filter.join("&"),
			limit: LimitTariffsFromOperator,
			providerJoin: true,
		},
		notifyOnNetworkStatusChange: true,
	});

	// Если данные загружаются, то выводим стаб
	if (!beautifulPhonesQuery?.data?.beautifulPhones?.data) {
		return <StubOperatorTariffs />;
	}

	let mobileTags = mobileTagsQuery?.data?.mobileTags?.data;
	let beautifulPhones = beautifulPhonesQuery?.data?.beautifulPhones?.data;

	// Дозагрузка номеров
	const fetchMorePhones = () => {
		beautifulPhonesQuery.fetchMore({
			variables: {
				offset: beautifulPhonesQuery.data.beautifulPhones.data.length,
			},
			updateQuery: (prev, { fetchMoreResult }) => {
				if (!fetchMoreResult) return prev;

				return Object.assign({}, prev, {
					beautifulPhones: {
						...prev.beautifulPhones,
						data: [...prev.beautifulPhones.data, ...fetchMoreResult.beautifulPhones.data],
					},
				});
			},
		});
	};

	return (
		<PaddingBottom>
			<Container>
				{canonical()}
				{!!beautifulPhones && !!beautifulPhones.length && <OfferBlock text={text} />}
				<TagButtonComponent
					mobileTags={mobileTags}
					tagCode={params.tagCode}
					beautifulNumbers={true}
					operatorStyle={true}
				/>
				{(!beautifulPhones || !beautifulPhones.length) && (
					<EmptyStubWrapper
						headerText={text.NO_PHONE_TARIFFS_HEADER}
						displayText={<NoTariffsInfo text={text} beautifulNumber={true} />}
						buttonText={text.TO_MAIN_PAGE}
						iconHeader={"icon-balance"}
						iconButton={"icon-playlist-add"}
					/>
				)}
				{!!beautifulPhones && !!beautifulPhones.length && (
					<Row>
						<BeautifulNumbersWrapper>
							{beautifulPhonesQuery.data.beautifulPhones.data.map((item, index) => {
								return <BeautifulNumbersRow isNumberRegion={true} tariff={item} key={index} />;
							})}
						</BeautifulNumbersWrapper>
					</Row>
				)}
				{beautifulPhonesQuery?.data?.beautifulPhones.data?.length <
					beautifulPhonesQuery?.data?.beautifulPhones?.pagination?.items_total && (
					<ShowMoreButton
						disabled={beautifulPhonesQuery.loading}
						windowSizes={windowSizes}
						text={text}
						onClickHandler={fetchMorePhones}
					/>
				)}
			</Container>
		</PaddingBottom>
	);
};

export default withRouter(withDefaultParams(inject("ApplicationModel")(Page)));
